const Request = require('@/repositories/request')
const qs = require('qs')

class ExperienceOther extends Request {
  /**
   *
   * @param {Object} params
   * @return {*}
   */
  find(params) {
    const stringifyParams = qs.stringify({ ...params }, { encode: false })
    return this.$strapi['$experience-others'].find(stringifyParams)
  }

  withUser(params) {
    const query = qs.stringify({ ...params }, { encode: false })
    return this.$strapi.$http.$get(`/experience-others/with-user?${query}`)
  }

  /**
   *
   * @param {int} id
   * @param queryObject
   * @returns {*}
   */
  findOne(id, queryObject) {
    const query = qs.stringify(queryObject, { encode: false })
    return this.$strapi.$http.$get(`/experience-others/${id}?${query}`)
  }

  /**
  *
  * @param {{_where: Object,
    _limit: int,
    _start: int}} params
  * @returns {*}
  */
  count(params) {
    const stringifyParams = qs.stringify({ ...params })
    return this.$strapi.count('experience-others', stringifyParams)
  }

  /**
   * @param {int} id
   * @param {Object} data
   * @returns {*}
   */
  update(id, data) {
    return this.$strapi['$experience-others'].update(id, data)
  }

  /**
   * @param {Object} data
   * @returns {*}
   */
  create(data) {
    return this.$strapi['$experience-others'].create(data)
  }

  /**
   * @param {int} id
   */
  delete(id) {
    return this.$strapi['$experience-others'].delete(id)
  }
}

module.exports = ExperienceOther
